import types from './mutations-types';

const actions = {
  async setDates({ commit }, obj) {
    commit(types.SET_DATES, obj);
  },
  async setDefaultDates({ commit }) {
    commit(types.SET_DEFAULT_DATES);
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/calendar/actions.js